import MultiStepForm from '@/components/forms/MultiStepForm';
import GeneralUserSubscriptions from '@/components/forms/apps/GeneralUserSubscriptions';
import WeclappInterfaceForm from '@/components/forms/apps/WeclappInterfaceForm';
import TanssInterfaceForm from '@/components/forms/apps/TanssInterfaceForm';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';
import TanssCrmSettingsForm from '@/components/forms/apps/crm/TanssCrmSettingsForm';
import CrmFrontendVisibilityForm from '@/components/forms/apps/crm/CrmFrontendVisibilityForm';
import OpenRouteInterfaceForm from '@/components/forms/apps/OpenRouteInterfaceForm';
import LLMInterfaceForm from '@/components/forms/apps/LLMInterfaceForm';

export default function CrmSetup({ app, onFinish, onCancel, deployment }) {
  const depl = deployment || {};
  const steps = [
    <WeclappInterfaceForm key="weclappInterface" app={app} />,
    <TanssInterfaceForm key="tanssInterface" app={app} />,
    <OpenRouteInterfaceForm key="openRouteInterface" app={app} />,
    <LLMInterfaceForm key="llmInterface" app={app} />,
    <CrmFrontendVisibilityForm key="crmFrontendVisibility" app={app} />,
    <TanssCrmSettingsForm key="tanssCrmSettings" app={app} />,
    <GeneralUserSubscriptions key="userSubcriptions" app={app} />,
  ];

  const handleSubmit = async (formData, users) => {
    const deploymentData = {
      app: app._id,
      config: {
        interfaces: {
          weclapp: formData.weclappInterface,
          tanss: formData.tanssInterface,
          openRoute: formData.openRouteInterface,
          llm: formData.llmInterface,
        },
        crm: {
          tanssDisplayName: formData?.tanssDisplayName ?? 'firstName lastName',
          hideQuickPartyEntryAction:
            formData?.hideQuickPartyEntryAction ?? false,
          hidePartyEntryAction: formData?.hidePartyEntryAction ?? false,
          hideFullSyncAction: formData?.hideFullSyncAction ?? false,
          tanssCategories: formData?.tanssCategories ?? {},
        },
      },
    };
    try {
      const deploymentResponse = await tenant.put(
        `/deployment/${depl.insertedId}`,
        deploymentData,
      );
      const { deployment } = deploymentResponse.data;
      await tenant.post('/subscription', {
        userIds: users,
        deploymentId: depl.insertedId,
      });
      onFinish(deployment, users);
    } catch (error) {
      try {
        await tenant.delete(`role/${formData?.printer?.role}`);
      } catch (error) {
        toast.error(
          <ToastMessage
            title="Fehler"
            subtitle={
              error?.response?.data?.message ||
              'Fehler beim Erstellen der Konfiguration'
            }
          />,
        );
      }
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  return (
    <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={onCancel} />
  );
}
